import { navigation } from '@/plugins/mixins/navigation'


export const purchase = {
  mixins: [navigation],
  computed: {
    purchase() {
      return this.$store.state.purchase;
    },
    event() {
      return this.$store.state.event.detail;
    },
    payment() {
      return this.$store.state.payment;
    },
    tickets() {
      return this.$store.state.tickets;
    },
  },
  methods: {
    async createPurchase(model, buyer) {
      let free = false
     this.firePurchaseLoadingEvent(true);
      let modelAux = 'purchase/create',
        data = this.purchase.tickets
      if (this.purchase.promoter_newsletter) {
        data.promoter_newsletter = this.purchase.promoter_newsletter
      }
      if (this.purchase.promoter_terms) {
        data.promoter_terms = this.purchase.promoter_terms
      }
      if (buyer && this.$store.state.buyer.detail.id) {
        data.buyer = this.$store.state.buyer.detail.id
      }

      if (model === 'seatsio') {
        modelAux = 'purchase/createSeatsio'
      } else if (model === 'onebox') {
        modelAux = 'purchase/createOnebox'
      }
      // Send post message Purchase
      window.parent.postMessage(
        {
          'event': 'Purchase',
          'data': JSON.stringify(
            {
              'ticket-types': data.tickets,
              'amount': this.purchase.detail.total_price
            })
        },
        '*');
      await this.$store.dispatch(modelAux, data)
      if (!this.purchase.detail.id) {
        this.showError();
        this.firePurchaseLoadingEvent(false);
        return
      }

      this.trackFbEvents();
      if (parseFloat(this.purchase.detail.total_price) === 0) {
        await this.$store.dispatch('payment/getMethods', {
          id: this.event.id
        })
        if (this.payment.methods.free) {
          free = true;
          await this.createFreePayment(buyer);
        }
      }

      this.fireGaTicketsEvents();

      if (free) {
        await this.navigateToThankYouPage(this.purchase.detail.reference);
      } else if (!free) {
        await this.navigateToPaymentUrl(this.purchase.detail.reference, data.buyer);
      }

     this.firePurchaseLoadingEvent(false);
    },
    firePurchaseLoadingEvent(loading) {
      this.$root.$emit('purchaseLoading', loading)
    },
    async createFreePayment(buyer) {
      const paymentData = {
        details: {
          type: 'free'
        },
        purchase: this.purchase.detail.id
      };
      if (buyer && this.$store.state.buyer.detail.id) {
        paymentData.buyer = this.$store.state.buyer.detail.id;
      }
      await this.$store.dispatch('payment/create', paymentData);
    },
    showError() {
      this.$root.$emit('closeModalInfo')
      if (typeof CustomEvent === 'function') {
        const event = new CustomEvent('showError', {
          detail: {
            textI18N: 'error.errorTitleI18N'
          }
        })
        window.dispatchEvent(event)
      }
    },
    fireGaTicketsEvents() {
      if (this.$store.state.tickets.selected.length > 0 && this.$store.state.purchase.detail.id) {
        this.$store.state.tickets.selected.forEach(item => {
          this.$ga.ecommerce.addItem({
            id: this.$store.state.purchase.detail.id.toString(),
            name: this.$store.state.event.detail.title,
            sku: this.$store.state.event.detail.id.toString(),
            price: item.price,
            quantity: item.quantity,
            currency: this.$store.state.event.detail.currency
          })
        })
        this.$ga.ecommerce.send()
      }
      this.$ga.event(
        'ecommerce',
        'purchase',
        this.$store.state.event.detail.title,
        this.$store.state.purchase.detail.id
      )
      if (
        typeof window.ga !== 'undefined' &&
        this.$store.state.event.detail.google_pixel_js !== ''
      ) {
        window.ga('Extra.send', 'pageview')
        if (this.$store.state.tickets.selected.length > 0 && this.$store.state.purchase.detail.id) {
          this.$store.state.tickets.selected.forEach(item => {
            window.ga('Extra.ecommerce:addItem', {
              id: this.$store.state.purchase.detail.id.toString(),
              name: this.$store.state.event.detail.title,
              sku: this.$store.state.event.detail.id.toString(),
              price: item.price,
              quantity: item.quantity,
              currency: this.$store.state.event.detail.currency
            })
          })
          window.ga('Extra.ecommerce:send')
        }
      }
    },
    trackFbEvents() {
      if (typeof window.fbq !== 'undefined') {
        window.fbq('track', 'InitiateCheckout', {
          content_name: this.event.title
        })
      }
      if (typeof window.fbq !== 'undefined') {
        const content_ids = this.tickets.selected.map(item => {
          return item.id
        })
        const contents = this.tickets.selected.map(item => {
          return {
            id: item.id,
            quantity: item.quantity,
            item_price: item.price
          }
        })
        window.fbq('track', 'AddToCart', {
          content_ids: content_ids,
          value: this.purchase.detail.total_price,
          currency: this.purchase.detail.currency,
          content_type: 'product',
          contents: contents
        })
      }
    }
  }
}
